import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { AppUrlService } from './nav/app-url.service';
import { AppUiCustomizationService } from './ui/app-ui-customization.service';
import { AppSessionService } from './session/app-session.service';
import { CookieConsentService } from './session/cookie-consent.service';

import { ServiceProxyModule as AxillaSharedServiceProxyModule } from '../../shared/service-proxies/service-proxy.module';
import { API_BASE_URL } from '../service-proxies/service-proxies';

import { AppConsts } from '../AppConsts';

export function getRemoteServiceBaseUrl(): string {
    return AppConsts.remoteServiceBaseUrl;
}

@NgModule({
    imports: [
        CommonModule,
        // AbpModule
        AxillaSharedServiceProxyModule,
    ]
})
export class AxillaCommonModule {
    static forRoot(): ModuleWithProviders<CommonModule> {
        return {
            ngModule: CommonModule,
            providers: [
                { provide: API_BASE_URL, useFactory: getRemoteServiceBaseUrl },

                AppUiCustomizationService,
                CookieConsentService,
                AppSessionService,
                AppUrlService
            ]
        };
    }
}
